import { Injectable } from '@angular/core';
import { apiNameList } from '../../../../environments/api-name-list';
import { HttpMethod } from '../../../common/enums/httpMethodEnum';
import { BaseService } from '../../../common/services/baseService';
import { HttpClientService } from '../../../common/services/httpClientService';
import { AppUtility } from '../../../common/utilities/appUtil';
import { AppSession } from '../../../common/values/appSession';
import { IHealthWiseResponse } from '../../../findcare/result/interfaces/iProviderSpeciality';

@Injectable({
  providedIn: 'root'
})
export class ProviderDescriptionSvc extends BaseService {
  constructor(
    public appSession: AppSession,
    public appUtility: AppUtility,
    public httpClientSvc: HttpClientService
  ) {
    super(appSession, appUtility, httpClientSvc);
  }

  /**
   * this method will call Node API to get procedure and specialities healthwise data
   * @param healthwiseReqObj
   */
  getHealthwiseProcedureAndSpecialityList(healthwiseReqObj: any): Promise<IHealthWiseResponse> {
    const header = this.getHeaders();
    return this.httpClientSvc.request({
      cancellable: true,
      method: HttpMethod.Post,
      url: this.baseURL + apiNameList.restApi.getProcedueAndSpecialityListDescription,
      data: healthwiseReqObj,
      headers: header
    });
  }
}
